import React, {useEffect, useState, useMemo} from "react";
import {Table, ImageStamp, TextInput, SearchButton, FilterDropdown, LightTextButton,TextLink, Loader} from "components";
import {useHistory} from "react-router-dom";
import {userSharesAction} from "redux/actions";
import * as XLSX from "xlsx";
import {allCartAction} from "redux/actions"; 
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import styles1 from "components/Tabs/styles.module.scss";
import {customersAction} from "redux/actions";
import {Modal} from "@material-ui/core";
import ReportModal from "../../Report/ReportModal";

export default function ({setDetails}) {
    // Routers
    const id = useHistory().location.pathname.split("/")[3];

    // Redux
    const dispatch = useDispatch();
    const [clickedCustomer, setClickedCustomer] = useState(null)
    const [clickedSubscription, setClickedSubscription] = useState(null)
    const [openModal, setOpenModal] = useState(false)

    const loading = useSelector(state => state.loading);

    const handleOpenModal = () => {
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const {customers, allCart, userRole} = useSelector(state => ({
        customers: state.customers?.users,
        allCart: state.allCart,
        userRole: state.userRole?.filter(role => role.module === "Users")
    }));

    // States
    const [tableRows, setTableRows] = useState();
    const [userId, setUserId] = useState('');
    const [cartId, setCartId] = useState('');
    const [userName, setUserName] = useState('');
    const [mobileNo, setmobileNo] = useState('');

   

    // Fetch Package Add On
    useEffect(() => {
        const {mobile, countrycode} =
        customers?.find(user => user?.userId == id) || {};

        dispatch(allCartAction.get({countryCode: '+92', mobile:"9811162674"}));
    }, [dispatch]);

    useEffect(() => {
        var filtered = allCart;

        if(cartId != ''){
            console.log('cartId'+cartId);
            filtered = allCart.filter((value)=>{
                if(value?.get_package_details?.cartID == cartId){
                    return value;
                }
            });
        }

        if(userId != ''){
            filtered = allCart.filter((value)=>{
                if(value.user_id == userId){
                    return value;
                }
            });
        }

        if(userName != ''){
            filtered = allCart.filter((value)=>{
                if(value.get_user_details?.first_name.toLowerCase() == userName.toLowerCase()){
                    return value;
                }
            });
        }

        if(mobileNo != ''){
            filtered = allCart.filter((value)=>{
                if(value.get_user_details?.mobile.toLowerCase() == mobileNo.toLowerCase()){
                    return value;
                }
            });
        }

        if (!filtered?.length) return;

        // filter based on Status
        //filtered = filtered?.filter();
        // Map table rows
        const data = filtered?.map(obj => ({
            user_id: (
                <TextLink
                    text={ obj?.user_id}
                    onClick={() => {
                        dispatch(
                            customersAction.get(1,100000)
                        )
                        // push(`${location.pathname}/${obj?.userId}`)
                        setClickedCustomer({id:  obj?.user_id, mobile: '', name: ''})
                        handleOpenModal()
                    }}
                />
            ),
            user_name: obj?.get_user_details?.first_name,
            user_mobile: obj?.get_user_details?.mobile,
            cart_id: obj?.get_package_details?.cartID,
            package_name: obj?.get_package_details?.package_name,
            created_at: `${new Date(obj.created_at).toLocaleString()}`
        }));
        
        setTableRows(data);
    }, [allCart,userId,userName,mobileNo,cartId]);

    

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Customer"
            },
            {
                title: "Name"
            },
            {
                title: "Mobile"
            },
            {
                title: "Cart"
            },
            {
                title: "Package"
            },
            {
                title: "Created",
                sortBy: "created_at"
            }
        ],
        [tableRows]
    );
    

    const exportShareData = () => {
        const rows = tableRows.map(obj => {
            return {
                "Customer": obj?.user_id,
                "User Name": obj?.user_name,
                "User Mobile": obj?.user_mobile,
                "Cart": obj?.cart_id,
                "Package Name": obj?.package_name,
                "Created At": `${new Date(obj.created_at).toLocaleString()}`
            }
        })
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "Datas.xlsx");
    }

    return (
        <div className={styles1.tabs}>
            <div className={styles1.header}>
                <ul><li class="styles_active__pKiYD">Cart</li></ul>
            </div>

            <div className={styles1.panel__wrapper}>
                <div className={styles.filter}>
                    <TextInput
                        label="Cart"
                        placeholder="Cart"
                        name="cart_id"
                        onChange={e => setCartId(e.target.value)}
                        value={cartId}
                    />

                    <TextInput
                        label="Customer"
                        placeholder="Customer ID"
                        name="user_id"
                        onChange={e => setUserId(e.target.value)}
                        value={userId}
                    />

                    <TextInput
                        label="User Name"
                        placeholder="Name"
                        name="user_name"
                        onChange={e => setUserName(e.target.value)}
                        value={userName}
                    />

                    <TextInput
                        label="Mobile"
                        placeholder="Mobile"
                        name="user_mobile"
                        onChange={e => setmobileNo(e.target.value)}
                        value={mobileNo}
                    />

                    {/* <button className={'btn btn-primary m-auto'} style={{marginTop: 20}} onClick={exportShareData}> Export Data </button> */}
                    
                    {loading ? (
                        <div className={styles.loading__container}>
                        <Loader />
                        </div>
                    ) : null}
                </div>
                <Table headers={tableHeaders} data={tableRows}/>
            </div>


            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                >
                <ReportModal clickedCustomer={clickedCustomer} handleCloseModal={handleCloseModal}
                            setClickedSubscription={setClickedSubscription}
                            handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>
        </div>
        
    );
};
